export const convertInchesToCm = (ft: number, inches: number): number => {
  let height = inches * 2.54
  height += ft * 30.48

  return height
}

export const convertLbsToKg = (lbs: number): number => {
  return lbs * 0.45359237
}
